module.exports = __webpack_public_path__ + "70358617c27f8ef47d94ae0224f6f152.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/comcast_2021_chart.png
// module id = 1654
// module chunks = 0